// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"5":"50b59bac","19":"dc251398","89":"98a3abda","135":"ed3786d7","170":"7984f428","174":"ab225317","217":"34038adf","447":"5284d26d","457":"87897593","466":"5560e389","540":"cc3092dd","561":"dd602e64","562":"0788f61f","644":"ad443dd1","812":"7d4bb812","910":"8a4f2410"}[chunkId] + ".js";
};